import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import _, { get } from "lodash";
import { Modal, Header, Close, Body } from "MODULES/shared/components/Modal";
import { REPAIR_STATION } from "MODULES/companies/constants";
import { CAP_AMOUNT } from "MODULES/PurchaseOrders/constants";
import { COMPANY } from "APP_ROOT/constants";
import Form from "./Form";
import { correctSerialText } from "../../../shared/helpers";

export default function Create({ open, close, lineItems }) {
  const [selectedCompany, setSelectedCompany] = useState({});
  const [returnToCompany, setReturnToCompany] = useState({});

  useEffect(
    () => {
      setSelectedCompany(
        get(
          lineItems,
          "[0].managed_repair_details.preferred_repair_station",
          {}
        )
      );

      return function cleanup() {};
    },
    [get(lineItems, "[0].id")]
  );

  const getActionRequested = item => {
    if (
      _.get(item, "customer_rma.warranty_consideration") &&
      !_.get(item, "customer_rma.closed_date")
    ) {
      return "warranty_consideration";
    } else if (item.cap_type) {
      return item.cap_type;
    }
    return null;
  };

  const getNotToExceed = item =>
    _.get(item, "sales_order_line_item.repair_fee") || _.get(item, CAP_AMOUNT);

  const pick = item => ({
    action_requested: getActionRequested(item),
    caac: !!selectedCompany.caac_approved,
    easa: !!selectedCompany.easa_approved,
    faa: !!selectedCompany.faa_approved,
    reason_for_return: _.get(item, "customer_rma.reason"),
    inventory_id: item.id,
    condition: item.condition,
    internal_note: !item.exchange_eval_in_progress
      ? _.get(item, "purchase_order_line_item.internal_note")
      : "",
    external_note: item.serial_number_correction_required
      ? correctSerialText(item)
      : "",
    flat_exchange: _.get(item, "sales_order_line_item.flat_exchange"),
    inventory: {
      suggested_retail: item.suggested_retail,
      srp_condition: item.srp_condition,
      most_recent_customer_rma: {
        code: _.get(item, "customer_rma.code"),
        credit_requested: _.get(item, "customer_rma.credit_requested")
      },
      purchase_order_line_item: item.purchase_order_line_item
    },
    not_to_exceed: getNotToExceed(item),
    payment_terms: selectedCompany.vendor_credit_terms,
    tcca: !!selectedCompany.tcca_approved
  });

  const storeLocation = lineItems.length > 0 && lineItems[0].store_location;
  const shipToFob = storeLocation && storeLocation.fob;

  const initialValues = {
    line_items: lineItems.map(pick),
    company_id: selectedCompany && selectedCompany.id,
    payment_terms: selectedCompany && selectedCompany.vendor_credit_terms,
    ship_to_type: REPAIR_STATION,
    ship_to_fob: shipToFob
  };

  if (
    lineItems.length === 1 &&
    !get(lineItems[0], "customer_rma.credit_requested") &&
    get(lineItems[0], "customer_rma.warranty_consideration") &&
    !get(lineItems[0], "customer_rma.closed_date")
  ) {
    initialValues.return_to_type = COMPANY;
    initialValues.return_to_company_id = get(
      lineItems[0],
      "customer_rma.company.id"
    );
    initialValues.return_to_company_address_id = get(
      lineItems[0],
      "customer_rma.company.primary_physical_address.id"
    );

    useEffect(
      () => {
        setReturnToCompany(get(lineItems[0], "customer_rma.company"));
        return function cleanup() {};
      },
      [get(lineItems, "[0].id")]
    );
  }

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Convert Cart to Repair Order</h4>
      </Header>
      <Body>
        <Form
          onSubmit={() => {}}
          close={close}
          formName="convertToRO"
          lineItems={lineItems}
          initialValues={initialValues}
          enableReinitialize
          returnToCompany={returnToCompany}
          selectedCompany={selectedCompany}
          setSelectedCompany={setSelectedCompany}
        />
      </Body>
    </Modal>
  );
}

Create.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  lineItems: PropTypes.arrayOf(PropTypes.shape({}))
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/ConvertToRo/Create.jsx